import { getCurrentPlan } from '@/services/subscription/subscription.service'
import { User } from '@/services/user/user.model'
import { getUser } from '@/services/user/user.service'
import { RootState } from '@/store'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UserStore {
  userInfo: User.Info | null,
  planPermissions: string[] | null,
}

const initialState: UserStore = {
  userInfo: null,
  planPermissions: null,
}

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
  return await getUser()
})

const onSetUser = (state: UserStore, user: User.Info) => {
  state.userInfo = user
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User.Info>) => {
      onSetUser(state, action.payload)
    },
    updateUser: (state, action: PayloadAction<User.Info>) => {
      onSetUser(state, { ...state.userInfo, ...action.payload })
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      onSetUser(state, action.payload)
    }).addCase(getCurrentPlanThunk.fulfilled, (state, action) => {
      state.planPermissions = action.payload.permissions?.map(item => item.code)
    })
  }
})

export const { setUser, updateUser } = userSlice.actions

export const selectUser = (state: RootState) => state.user
export const selectPlanPermissions = (state: RootState) => state.user.planPermissions


export const getCurrentPlanThunk = createAsyncThunk('user/getCurrentPlanThunk', async () => {
  return await getCurrentPlan()
})